"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createCognitiveServicesSpeechServicesPonyfillFactory;

var _AudioConfig = require("microsoft-cognitiveservices-speech-sdk/distrib/lib/src/sdk/Audio/AudioConfig");

var _SpeechServices = _interopRequireDefault(require("web-speech-cognitive-services/lib/SpeechServices"));

function createCognitiveServicesSpeechServicesPonyfillFactory(_ref) {
  var audioConfig = _ref.audioConfig,
      authorizationToken = _ref.authorizationToken,
      enableTelemetry = _ref.enableTelemetry,
      region = _ref.region,
      speechRecognitionEndpointId = _ref.speechRecognitionEndpointId,
      speechSynthesisDeploymentId = _ref.speechSynthesisDeploymentId,
      speechSynthesisOutputFormat = _ref.speechSynthesisOutputFormat,
      subscriptionKey = _ref.subscriptionKey,
      textNormalization = _ref.textNormalization; // HACK: We should prevent AudioContext object from being recreated because they may be blessed and UX-wise expensive to recreate.
  //       In Cognitive Services SDK, if they detect the "end" function is falsy, they will not call "end" but "suspend" instead.
  //       And on next recognition, they will re-use the AudioContext object.

  if (!audioConfig) {
    audioConfig = _AudioConfig.AudioConfig.fromDefaultMicrophoneInput();
    var source = audioConfig.privSource; // This piece of code is adopted from microsoft-cognitiveservices-speech-sdk/common.browser/MicAudioSource.ts.
    // Instead of closing the AudioContext, it will just suspend it. And the next time it is needed, it will be resumed (by the original code).

    source.destroyAudioContext = function () {
      if (!source.privContext) {
        return;
      }

      source.privRecorder.releaseMediaResources(source.privContext);
      source.privContext.state === 'running' && source.privContext.suspend();
    };
  }

  return function (_ref2) {
    var referenceGrammarID = _ref2.referenceGrammarID;
    var ponyfill = (0, _SpeechServices.default)({
      audioConfig: audioConfig,
      authorizationToken: authorizationToken,
      enableTelemetry: enableTelemetry,
      referenceGrammars: ["luis/".concat(referenceGrammarID, "-PRODUCTION")],
      region: region,
      speechRecognitionEndpointId: speechRecognitionEndpointId,
      speechSynthesisDeploymentId: speechSynthesisDeploymentId,
      speechSynthesisOutputFormat: speechSynthesisOutputFormat,
      subscriptionKey: subscriptionKey,
      textNormalization: textNormalization
    });
    var SpeechGrammarList = ponyfill.SpeechGrammarList,
        SpeechRecognition = ponyfill.SpeechRecognition,
        speechSynthesis = ponyfill.speechSynthesis,
        SpeechSynthesisUtterance = ponyfill.SpeechSynthesisUtterance;
    return {
      SpeechGrammarList: SpeechGrammarList,
      SpeechRecognition: SpeechRecognition,
      speechSynthesis: speechSynthesis,
      SpeechSynthesisUtterance: SpeechSynthesisUtterance
    };
  };
}